import request from '@/utils/request'
import qs from 'qs'

// 修改手机号-验证身份
const user_authPhone = (data) => {
  return request({
    url: '/user/authPhone',
    method: 'post',
    data
  })
}

// 验证账号
const user_checkPhone = (params, headers) => {
  return request({
    url: '/user/checkPhone',
    method: 'get',
    params,
    headers
  })
}

// 修改手机号码
const user_modifyPhone = (data) => {
  return request({
    url: '/user/modifyPhone',
    method: 'post',
    data
  })
}

// 修改密码
const user_modifyPwd = (data) => {
  return request({
    url: '/user/modifyPwd',
    method: 'post',
    data
  })
}

// 用户注册
const user_register = (data) => {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

// 找回密码
const user_retrievePwd = (data) => {
  return request({
    url: '/user/retrievePwd',
    method: 'post',
    data

  })
}

// 找回密码-验证身份(分步方式)
const user_retrievePwdAuth = (data) => {
  return request({
    url: '/user/retrievePwdAuth',
    method: 'post',
    data
  })
}

// 找回密码-修改密码(分步方式)
const user_retrievePwdModify = (data) => {
  return request({
    url: '/user/retrievePwdModify',
    method: 'post',
    data
  })
}

// 获取播放凭证
const user_playAuth = (params) => {
  return request({
    url: '/user/video/playAuth',
    method: 'get',
    params
  })
}

// 意向报名
const intention_apply = (projectNo) => {
  return request({
    url: '/user/intention/apply?projectNo=' + projectNo,
    method: 'post'
  })
}

// 消息详情
const msg_info = (id) => {
  return request({
    url: '/user/msg/info?id=' + id
  })
}

// 消息列表
const msg_list = (params) => {
  return request({
    url: '/user/msg/list',
    params
  })
}

// 全部已读
const msg_readAll = (data) => {
  return request({
    url: '/user/msg/readAll',
    method: 'post',
    data
  })
}

// 附件下载
const msg_download = (data) => {
  return request({
    url: '/user/msg/download',
    method: 'post',
    responseType: 'blob',
    data: qs.stringify(data, { arrayFormat: 'repeat' }),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  })
}

// 站点交易品种
const user_common_tradeKind = (params) => {
  return request({
    url: '/user/common/trade/kind',
    params
  })
}

export {
  msg_download,
  msg_info,
  msg_list,
  msg_readAll,
  user_authPhone,
  user_checkPhone,
  user_modifyPhone,
  user_modifyPwd,
  user_register,
  user_retrievePwd,
  user_retrievePwdAuth,
  user_retrievePwdModify,
  user_playAuth,
  intention_apply,
  user_common_tradeKind
}
